import './footer.css'

const year = new Date().getFullYear();

const Footer = () => {
  return (
    <footer className="footer">
      Copyright &copy; {year} princegearyd.com | All rights reserved.
    </footer>
  )
}

export default Footer